import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed';

const Account = {
  Profile: lazy(() => import('./containers/Profile')),
  Company: lazy(() => import('./containers/Company')),
  CompanyTab: lazyNamed(() => import('./containers/Company/tabs'), 'CompanyTab'),
  CompanyUserRolesList: lazyNamed(() => import('./containers/Company/tabs'), 'UserRolesList'),
  Users: lazy(() => import('./containers/Users')),
  EditUser: lazyNamed(() => import('./containers/EditUser'), 'EditUser'),
  AdminAccessHistory: lazyNamed(() => import('./containers/AdminAccessHistory'), 'AdminAccessHistory'),
};

export default Account;
